import React, { Component } from "react";
import axios from "axios";
import ApiURL from "../../api/ApiURL";
import cogoToast from "cogo-toast";
import LocalStorageHelper from "../../LocalStorageHelper/LocalStorageHelper";
import PageTitle from "../home/PageTitle";
import AgGridComponent from "../common/AgGridComponent";
import PaginationComponent, { DEFAULT_PAGE_SIZE, DEFAULT_PAGE_SIZE_OPTIONS } from "../common/PaginationComponent";
import { createMasterActionColumn, createMasterActiveColumn } from "../../utils/masterGridHelpers";
import {
  buildMasterGridParams,
  URL_SORT_WHITELIST,
  URL_FILTER_WHITELIST,
} from "../../utils/agGridServerHelpers";


class URL extends Component {
  //constructor lifecycle event
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      showDeleteWarnModal: false,
      URLData: [],
      columnDefs: [],
      sortModel: [],
      filterModel: {},
      isTableLoading: true,
      TCData: [],
      SPLData: [],
      urlId: 0,
      urlName: "",
      travelCircuitId: 0,
      specialistId: 0,
      userId: 0,
      userRole: '',
      isActive: false,
      currentPage: 1,
      pageSize: DEFAULT_PAGE_SIZE,
      totalRecords: 0,
    };
  }
  //componentDidMount lifecycle event
  componentDidMount() {
    window.scroll(0, 0);
    var userData = JSON.parse(LocalStorageHelper.getUser());
    if (userData !== null && userData.UserId > 0) {
      this.setState({
        userId: userData.UserId,
        userRole: userData.RoleName,
        displayName: userData.DisplayName
      })
    }
    this.getAllURLData();
    this.getAllDataColumns();
    this.getAllTCData();
    this.getAllSPLData();
  }
  //Data Reload
  handleReload = () => this.setState({ currentPage: 1 }, this.getAllURLData);
  handleSortChange = (sortModel) => {
    this.setState({ sortModel, currentPage: 1 }, this.getAllURLData);
  };
  handleFilterChange = (filterModel) => {
    this.setState({ filterModel, currentPage: 1 }, this.getAllURLData);
  };
  handlePageChange = (page) => {
    this.setState({ currentPage: page }, this.getAllURLData);
  };
  handlePageSizeChange = (size) => {
    this.setState({ pageSize: size, currentPage: 1 }, this.getAllURLData);
  };
  //Open modal
  openModal = () => this.setState({ showModal: true });
  //Close modal
  closeModal = () => this.setState({ showModal: false });
  //Open Delete warning modal
  openWarnModal = () => this.setState({ showDeleteWarnModal: true });
  //Close Delete warning modal
  closeWarnModal = () => this.setState({ showDeleteWarnModal: false });
  //OnChangeHandler
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }
  //Get all data
  getAllURLData = () => {
    const { currentPage, pageSize, sortModel, filterModel } = this.state;
    const param = buildMasterGridParams(
      currentPage,
      pageSize,
      sortModel,
      filterModel,
      URL_SORT_WHITELIST,
      URL_FILTER_WHITELIST
    );
    this.setState({ isTableLoading: true });
    axios
      .post(ApiURL.GetAllURL, param)
      .then((response) => {
        let respData = response.data;
        if (respData.StatusCode === 200) {
          var dataResult = respData.DataResult;
          this.setState({
            URLData: dataResult.URLs,
            totalRecords: dataResult?.TotalRecords ?? 0,
          });
        } else if (respData.StatusCode === 404) {
          this.setState({ URLData: [], totalRecords: 0 });
        } else if (respData.StatusCode === 500) {
          cogoToast.error("Internal Server Error ! Please Try Again.", {
            position: "bottom-center",
          });
        }
      })
      .catch((error) => {
        cogoToast.error("Request Failed! Please Try Again.", {
          position: "bottom-center",
        });
      })
      .finally(() => {
        this.setState({ isTableLoading: false });
      });
  }
  //Get all columns
  getAllDataColumns = () => {
    this.setState({
      columnDefs: [
        createMasterActionColumn(this.getDataItemById, "UrlId"),
        { headerName: "URL", field: "UrlName", flex: 1.5, minWidth: 160, cellClass: "text-left" },
        { headerName: "Travel Circuit", field: "TravelCircuitName", width: 140, cellClass: "text-center" },
        { headerName: "Specialist", field: "SpecialistName", flex: 1, minWidth: 120, cellClass: "text-left" },
        createMasterActiveColumn(),
      ],
    })
  }
  //Get data by Id
  getDataItemById = (keyData) => {
    var self = this;
    axios
      .get(ApiURL.GetURLById(keyData))
      .then((response) => {
        let respData = response.data;
        if (respData.StatusCode === 200) {
          var dataResult = respData.DataResult;

          self.setState({
            urlId: dataResult.UrlId,
            urlName: dataResult.UrlName,
            travelCircuitId: dataResult.TravelCircuitId,
            specialistId: dataResult.SpecialistId,
            showModal: true,
          });
        } else if (respData.StatusCode === 500) {
          cogoToast.error("Internal Server Error ! Please Try Again.", {
            position: "bottom-center",
          });
        }
      })
      .catch((error) => {
        cogoToast.error("Request Failed! Please Try Again.", {
          position: "bottom-center",
        });
      });
  }
  //Get all Travel Circuit data
  getAllTCData = () => {
    axios
      .get(ApiURL.GetAllTC)
      .then((response) => {
        let respData = response.data;
        if (respData.StatusCode === 200) {
          var dataResult = respData.DataResult;          
          var travelCircuit = [
            { TravelCircuitId: 0, TravelCircuitName: "-- Select --" },
          ];
          if (dataResult.length > 0) {
            for (var i = 0; i < dataResult.length; i++) {
              travelCircuit.push({
                TravelCircuitId: dataResult[i].TravelCircuitId,
                TravelCircuitName: dataResult[i].TravelCircuitName,
              });
            }
          }

          this.setState({ TCData: travelCircuit });
        } else if (respData.StatusCode === 500) {
          cogoToast.error("Internal Server Error ! Please Try Again.", {
            position: "bottom-center",
          });
        }
      })
      .catch((error) => {
        cogoToast.error("Request Failed! Please Try Again.", {
          position: "bottom-center",
        });
      });
  }
  //Get all Specialist(name) data
  getAllSPLData = () => {
    axios
      .get(ApiURL.GetAllSPL)
      .then((response) => {
        let respData = response.data;
        if (respData.StatusCode === 200) {
          var dataResult = respData.DataResult;          
          var specialists = [
            { SpecialistId: 0, SpecialistName: "-- Select --" },
          ];
          if (dataResult.length > 0) {
            for (var i = 0; i < dataResult.length; i++) {
              specialists.push({
                SpecialistId: dataResult[i].SpecialistId,
                SpecialistName: dataResult[i].SpecialistName,
              });
            }
          }          
          this.setState({ SPLData: specialists });
        } else if (respData.StatusCode === 500) {
          cogoToast.error("Internal Server Error ! Please Try Again.", {
            position: "bottom-center",
          });
        }
      })
      .catch((error) => {
        cogoToast.error("Request Failed! Please Try Again.", {
          position: "bottom-center",
        });
      });
  }
  //Handle Add new Record
  handleAddNew = () => {
    this.resetInputFields();
    this.openModal();
  }
  //Reset all input fields into the modal
  resetInputFields = () => {
    this.setState({
      showModal: false,
      showDeleteWarnModal: false,
      urlId: 0,
      urlName: "",
      travelCircuitId: 0,
      specialistId: 0,
      isActive: false
    });
  }
  //Delete data by Id
  handleDelete = () => {
    let param = {
      urlId: this.state.urlId,
      isActive: this.state.isActive,
    };

    axios
      .post(ApiURL.DeleteURL, param)
      .then((response) => {
        let respData = response.data;

        if (respData.StatusCode === 200) {

          this.resetInputFields();
          //call data load
          this.closeWarnModal();
          this.closeModal();
          this.getAllURLData();
          //Show success message
          cogoToast.success("URL Deleted Successfully!", { position: "top-center" });

        } else if (respData.StatusCode === 500) {
          cogoToast.error("Internal Server Error ! Please Try Again.", {
            position: "bottom-center",
          });
        }
      })
      .catch((error) => {
        console.error("Server Error:", error);
        cogoToast.error("Request Failed! Please Try Again.", {
          position: "bottom-center",
        });
      });
  }
  //Save dta
  handleSubmit = (e, urlId) => {
    e.preventDefault();

    //set the blank validation
    if (!this.state.urlName || !this.state.travelCircuitId || !this.state.specialistId) {
      cogoToast.error("Please fill all required fields.", { position: "bottom-center" });
      return;
    }

    let param = {
      urlId: this.state.urlId,
      urlName: this.state.urlName,
      travelCircuitId: parseInt(this.state.travelCircuitId),
      specialistId: parseInt(this.state.specialistId),
      isActive: true
    };

    axios
      .post(ApiURL.SaveURL, param)
      .then((response) => {
        let respData = response.data;
        if (respData.StatusCode === 200) {
          cogoToast.success("URL Saved Successfully!", { position: "bottom-center" });
          this.resetInputFields();
          this.getAllURLData();
        }
        else if (respData.StatusCode === 500) {
          cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
        }
      })
      .catch((error) => {
        cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
      });
  }
  //render lifecycle event.
  render() {
    var self = this;
    const { showModal, TCData, travelCircuitId, SPLData, specialistId, urlId, showDeleteWarnModal, URLData, columnDefs,
      currentPage, pageSize, totalRecords } = self.state;
    return (
      <>
        <div className="master-page">
        <div className="container-fluid bg-primary-subtle border-bottom border-primary top-action-bar">
          <div className="card bg-primary-subtle flex-row py-1 mb-0 mx-2">
            <div className="col-md-9 justify-content-start">
              <PageTitle Title="Manage URL" />
            </div>
            <div className="col-md-3 text-right pt-1">
              <button className="btn btn-outline-dark btn-sm px-3 mx-3" title="Refresh" onClick={this.handleReload}>
                <i className="fa-solid fa-arrows-rotate"></i> Refresh
              </button>
              <button className="btn btn-outline-primary btn-sm px-3 cursor-pointer" title="Add" onClick={this.handleAddNew}>
                <i className="fa-solid fa-plus"></i> Add
              </button>
            </div>
          </div>
        </div>

        <div className="master-page__body">
          <PaginationComponent
            currentPage={currentPage}
            totalPages={Math.ceil(totalRecords / pageSize) || 1}
            pageSize={pageSize}
            totalRecords={totalRecords}
            pageSizeOptions={DEFAULT_PAGE_SIZE_OPTIONS}
            onPageChange={this.handlePageChange}
            onPageSizeChange={this.handlePageSizeChange}
          />
          <div className="master-page__grid">
            <AgGridComponent
              columnDefs={columnDefs}
              rowData={URLData}
              isLoading={this.state.isTableLoading}
              onSortChange={this.handleSortChange}
              onFilterChange={this.handleFilterChange}
              fillHeight
            />
          </div>
        </div>
        </div>

        {/* <!----------------- modal section----------------> */}
        <div
          className={showModal === true ? "modal show-modal  modalWrapper" : "modal"}
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title ">
                  {urlId <= 0 ? `Add URL` : `Update URL`}
                </h1>
                <i className="fa-regular fa-circle-xmark text-danger" data-bs-dismiss="modal" onClick={this.closeModal}></i>
              </div>
              <div className="modal-body">
                <div className="row ">
                  <div className="col-12 mb-2 position-relative">
                    <label
                      htmlFor="validationCustom03"
                      className="form-label text-sm"
                      style={{ fontSize: "15px" }}
                    >
                      Url Name *
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="URL Name"
                      aria-label="url name"
                      name="urlName"
                      value={this.state.urlName}
                      onChange={this.handleChange}
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <label
                      htmlFor="tavelCircuit"
                      className="form-label text-sm"
                      style={{ fontSize: "15px" }}
                    >
                      Travel Circuit *
                    </label>
                    <select
                      className="form-control"
                      name="travelCircuitId"
                      value={travelCircuitId}
                      onChange={this.handleChange}
                      required
                    >
                      {TCData.map((item, index) => (
                        <option key={index} value={item.TravelCircuitId}>
                          {item.TravelCircuitName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label
                      htmlFor="specialistName"
                      className="form-label "
                      style={{ fontSize: "15px" }}
                    >
                      Specialist Name *
                    </label>
                    <select
                      className="form-control"
                      name="specialistId"
                      value={specialistId}
                      onChange={this.handleChange}
                      required
                    >
                      {SPLData.map((item, index) => (
                        <option key={index} value={item.SpecialistId}>
                          {item.SpecialistName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className="modal-footer my-3">
                <button
                  type="submit"
                  className="btn btn-success button-box-shadow"
                  onClick={this.handleSubmit}
                >
                  <i className="fa-solid fa-circle-check"></i> Save
                </button>
                {
                  this.state.userRole === 'admin' &&
                  <button
                    type="button"
                    className={`btn btn-danger button-box-shadow curser-pointer ${urlId > 0 ? "" : "disabled"
                      }`}
                    onClick={() => {
                      urlId > 0 && this.openWarnModal();
                    }}
                  >
                    <i className="fa-solid fa-trash-can"></i> Delete
                  </button>
                }

                <button
                  type="button"
                  className="btn btn-secondary button-box-shadow"
                  data-bs-dismiss="modal"
                  onClick={this.closeModal}
                >
                  <i className="fa-solid fa-circle-xmark"></i> Close
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* <!------DELETE Warning Modal--------> */}
        <div className={showDeleteWarnModal === true ? "modal show-modal " : "modal"}>
          <div className="modal-dialog modal-dialog-centered modal-md">
            <div className="modal-content button-box-shadow">
              <div className="modal-body">
                <div className="alert alert-warning d-flex align-items-center" role="alert">
                  <i className="fa-solid fa-triangle-exclamation"></i>
                  &nbsp;
                  <div>
                    <strong>Are you sure</strong>, you want to <strong>Delete </strong> it?
                  </div>
                </div>
              </div>
              <div className="modal-footer ">
                <button
                  type="button"
                  className="btn btn-danger button-box-shadow btn-sm"
                  onClick={this.handleDelete}
                >
                  <i className="fa-solid fa-trash-can"></i> Delete
                </button>

                <button
                  type="button"
                  className="btn btn-secondary button-box-shadow btn-sm"
                  data-bs-dismiss="modal"
                  onClick={this.closeWarnModal}
                >
                  <i className="fa-solid fa-circle-xmark"></i> Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default URL;
